// extracted by mini-css-extract-plugin
module.exports = {"card_container":"card-module--card_container--3nx6C","card_img":"card-module--card_img--10JNj","link":"card-module--link--2pvy9"};